import React, { useContext } from "react"
import Grid from "../grid"
import {
  PlatformLayersImg,
  OverlayStyle,
} from "./mappeidn-layers.graphiclist.style"
import LayerFeatureList from "./mappedin-layers.featurelist"
import { UIContext } from "../layout"

export default function MappedinLayersGraphiclist({
  overlayLayer = 1,
  assets,
}) {
  const { layersSvg, iconLayer1, iconLayer2 } = assets

  const {
    state: { breakpoint },
  } = useContext(UIContext)

  return (
    <>
      <Grid>
        <PlatformLayersImg src={layersSvg.publicURL} />
        <LayerFeatureList
          logoSrc={iconLayer1.publicURL}
          logoAlt='An icon showing rectangular layers stacked on top of each other next to the text "Layer 1'
          title="Digital Foundation"
          description="Delivered through Mappedin's enterprise-grade CMS."
          color={overlayLayer === 1 && "var(--burnt-orange)"}
        >
          <li>Automated Map Digitization</li>
          <li>Map Editor</li>
          <li>Data Management</li>
        </LayerFeatureList>
      </Grid>
      <Grid>
        <LayerFeatureList
          logoSrc={iconLayer2.publicURL}
          logoAlt='An icon showing rectangular layers stacked on top of each other next to the text "Layer 2'
          title="Developer Tools"
          description="Delivered through SDKs, exports, and syncs."
          color={overlayLayer === 2 && "var(--burnt-orange)"}
        >
          <li>Web SDK</li>
          <li>Mobile SDK</li>
          <li>MVF Export</li>
          <li>IMDF Export</li>
          <li>Analytics API</li>
          <li>Directions API</li>
        </LayerFeatureList>
      </Grid>
    </>
  )
}
